import { confidenceDisplayRuleFor } from '../registry/customer360Confidence';
import { CardConfidence } from '../types';
import { CardConfidenceInput, cardConfidenceFrom } from './cardConfidence';

/**
 * Customer 360's binding of the shared card-confidence rule: the computation is
 * `data/cardConfidence.ts`, and the only thing this layer supplies is its own `Show Confidence
 * Score?` table (`registry/customer360Confidence.ts`, the `C-*` catalogue).
 *
 * That table IS the isolation. `product_readiness`, `ready_for_engagement`, `contact_restrictions`
 * and `risk_unusual_activity` are card keys BOTH registries declare, so a Layer 1 identifier reaching
 * this function must contribute nothing: `confidenceDisplayRuleFor('O-COM-020')` is `undefined`,
 * which is not `'yes'`, so it is never eligible and never reaches the mean. PLA-8828.
 */
export const customer360CardConfidence = (
  inputs: CardConfidenceInput[]
): CardConfidence | undefined => cardConfidenceFrom(confidenceDisplayRuleFor, inputs);

export type { CardConfidenceInput, ConfidenceReasonRule } from './cardConfidence';
export { CONFIDENCE_REASON_RULES, confidenceReasonRuleFor } from './cardConfidence';

export default customer360CardConfidence;
